import React, { useState } from 'react';
import { Slider, Box, Typography } from '@mui/material';

export default function HueSlider({ hue, setHue, onMouseUp }) {

  return (
    <Box >
      <Slider
        value={hue}
        min={0}
        max={360}
        onChange={(e, value) => setHue(value)}
        onMouseUp={onMouseUp}
        sx={{
          width: 200,
          height: 8,
          '& .MuiSlider-track': {
            border: 'none',
          },
          '& .MuiSlider-rail': {
            background: 'linear-gradient(to right, red, yellow, lime, cyan, blue, magenta, red)',
          },
          '& .MuiSlider-thumb': {
            height: 24,
            width: 24,
            backgroundColor: '#fff',
            border: '2px solid currentColor',
            '&:focus, &:hover, &.Mui-active': {
              boxShadow: '0 0 0 8px rgba(0, 0, 0, 0.16)',
            },
          },
        }}
      />
    </Box>
  );
}
